import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Sender/SenderFileDropOverlay";
import { cn } from "utils";
import type { SenderFileDragPhase } from "./useSenderFileDropInteraction";
import { Icon, ospThemes } from "@ospweb/sdk-ui";

const I18n = I18nUtil.createScoped(Translations);

type SenderFileDropOverlayProps = {
  phase: SenderFileDragPhase;
  className?: string;
};

export function SenderFileDropOverlay({
  phase,
  className,
}: SenderFileDropOverlayProps) {
  if (phase === "idle") {
    return null;
  }

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 z-20 flex min-h-[180px] items-center justify-center overflow-hidden rounded-3 border border-border_brand_transparent20 transition-colors",
        className,
      )}
      aria-hidden="true"
    >
      <div className="absolute inset-0 bg-background_solid_neutral_secondary" />
      <div
        className={cn(
          "absolute inset-0",
          phase === "over"
            ? "bg-background_brand_overlay10"
            : "bg-background_brand_overlay5",
        )}
      />
      <div className="relative z-[1] flex flex-col items-center justify-center gap-2 text-content_brand_primary">
        <Icon
          name="paperclip"
          size={32}
          color={ospThemes.colors.content_brand_primary}
        />
        <span className="body_medium_m">{I18n.t("Drop files here")}</span>
      </div>
    </div>
  );
}
